<template>
  <custom-page-form mode="create" />
</template>

<script>
import CustomPageForm from "./CustomPageForm.vue";

export default {
  components: { CustomPageForm },
};
</script>
